import React from 'react';
import { SERVICES } from '../../lib/site';
import { SectionHeading } from '../ui/SectionHeading';
import { ServiceCard } from '../ui/ServiceCard';
import { MagneticButton } from '../fx/MagneticButton';
import { Reveal } from '../fx/Reveal';
export function ServicesSection({
  limit
}: {
  limit?: number;
}) {
  const list = limit ? SERVICES.slice(0, limit) : SERVICES;
  return <section className="relative mx-auto max-w-7xl px-6 py-24" data-id="element-306" data-mp="2vwpqjyhbhsb2">
      <SectionHeading eyebrow="Full-Service Restoration & Construction" title="Everything Your Home Needs, Under One Roof" subtitle="From emergency restoration to luxury remodels — a single trusted partner for protecting and elevating your home." data-id="element-307" data-mp="2vy96tp2z43cu" />
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-308" data-mp="2hxyfkkxr4mr5">
        {list.map((service, i) => <ServiceCard key={service.slug} service={service} index={i} data-id="element-309" data-mp="l3va84cw06wn" data-mpi={i} />)}
      </div>
      {limit && <Reveal className="mt-12 flex justify-center" data-id="element-310" data-mp="g3gyocc2uetv">
          <MagneticButton variant="ghost" to="/services" data-id="element-311" data-mp="2rt0ysb7c2a5i">
            View All Services
          </MagneticButton>
        </Reveal>}
    </section>;
}